import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=87fe7610&scoped=true&"
import script from "./growth.vue?vue&type=script&lang=js&"
export * from "./growth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fe7610",
  null
  
)

export default component.exports